var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwardMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_1391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84199 11.5752L5.83366 19.1668L10.0003 16.6668L14.167 19.1668L13.1587 11.5668M15.8337 6.66683C15.8337 9.88849 13.222 12.5002 10.0003 12.5002C6.77866 12.5002 4.16699 9.88849 4.16699 6.66683C4.16699 3.44517 6.77866 0.833496 10.0003 0.833496C13.222 0.833496 15.8337 3.44517 15.8337 6.66683Z",
    stroke: "url(#paint0_linear_1337_1391)",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1337_1391",
    x1: 4,
    y1: 2.5,
    x2: 16,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F56D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63C2E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_1391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardMin);
export default __webpack_public_path__ + "static/media/award-min.377786ae5664d43e3ee2f850ff71b3a9.svg";
export { ForwardRef as ReactComponent };